<template>
  <div class="menu-mobile-main">
    <div class="menu-mobile-main__header">
      <a href="/">
        <svg class="menu-mobile-main__logo"><use xlink:href="#svg-menu-logo"></use></svg>
      </a>
      <span class="menu-mobile-main__close" @click="$emit('close')">
        <svg><use xlink:href="#svg-close"></use></svg>
      </span>
    </div>
    <div class="menu-mobile-main__main">
      <div class="menu-mobile-block">
        <div class="menu-mobile-main__menu" @click="$emit('openMenu')">
          <svg class="menu-mobile-main__icon">
            <use xlink:href="#svg-clock"></use>
          </svg>
          {{ mainMenu.catalogTitle }}
          <svg class="menu-mobile-main__arrow"><use xlink:href="#svg-arrow-right"></use></svg>
        </div>
        <div class="menu-mobile-main__menu" @click="$emit('openCollection')">
          <svg class="menu-mobile-main__icon"><use xlink:href="#svg-rings"></use></svg>
          {{ messages.collections }}
          <svg class="menu-mobile-main__arrow"><use xlink:href="#svg-arrow-right"></use></svg>
        </div>
      </div>

      <div class="menu-mobile-block">
        <MenuEntry v-if="getPersonalMenu" :result="getPersonalMenu" />
      </div>

      <div class="menu-mobile-block">
        <div class="menu-mobile-item"><MenuFavourite /></div>
        <div class="menu-mobile-item"><MenuBasket /></div>
      </div>
      <div class="menu-mobile-block">
        <div class="menu-mobile-item">
          <DeliveryCountry />
        </div>
      </div>

      <div class="menu-mobile-block">
        <CurrencyToggle />
      </div>

      <div class="menu-mobile-block">
        <div class="menu-mobile-service">
          <a
            v-for="item in serviceMenu.items"
            :key="item.href"
            :href="item.href"
            class="menu-mobile-service__item"
          >
            {{ item.name }}
          </a>
        </div>
      </div>
      <div class="menu-mobile-block">
        <div class="menu-mobile-item">
          <span> {{ messageLang }}: </span>
          <DefLang />
        </div>
      </div>

      <div class="menu-mobile-footer">
        <div class="menu-footer-item">
          <span class="menu-footer-item__title">{{ store.messages.eShopPhone }}</span>

          <a :href="`tel:${store.eShopPhone}`">
            {{ store.eShopPhone }}
          </a>
        </div>
        <div class="menu-footer-item">
          <span class="menu-footer-item__title">{{ store.messages.eShopServicePhone }}</span>
          <a :href="`tel:${store.eShopServicePhone}`">
            {{ store.eShopServicePhone }}
          </a>
        </div>
        <div class="menu-footer-item">
          <span class="menu-footer-item__title">{{ store.messages.eShopEmail }}</span>
          <a :href="'mailto:' + store.eShopMail + '?subject=' + store.messages.eShopMailSubject">
            {{ store.eShopMail }}
          </a>
        </div>
        <div class="menu-footer-item">
          <div class="menu-mobile-times" v-html="store.eShopTimeTable"></div>
        </div>

        <div class="menu-footer-item">
          <span class="menu-footer-item__title">{{ store.messages.eShopSocialMedia }}</span>
          <DefSocial />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import MenuEntry from '@components/Menu/MenuMobile/MenuEntry.vue';
import DefLang from '@components/Def/DefLang/DefLang.vue';
import DefSocial from '@components/Def/DefSocial/DefSocial.vue';
import DeliveryCountry from '@components/Header/DeliveryCountry/DeliveryCountry.vue';
import MenuFavourite from '@components/Menu/MenuMobile/MenuFavourite.vue';
import MenuBasket from '@components/Menu/MenuMobile/MenuBasket.vue';
import CurrencyToggle from '@components/Header/Currency/CurrencyToggle.vue';

export default {
  name: 'MenuMobileMain',
  components: {
    CurrencyToggle,
    MenuBasket,
    MenuFavourite,
    DeliveryCountry,
    DefSocial,
    DefLang,
    MenuEntry,
  },
  computed: {
    ...mapState({
      mainMenu: ({ results }) => results.menus.mainMenu,
      serviceMenu: ({ results }) => results.menus.serviceMenu,
      personalMenuMobile: ({ results }) => results.menus.personalMenuMobile,
      messages: ({ results }) => results.messages,
      messageLang: ({ results }) => results?.siteLanguages?.messages?.lang,
      isAuthorized: ({ personal }) => personal?.data?.authInfo.isAuthorized,
      store: ({ results }) => results?.storeInformation,
    }),
    /**
     * if user isn't authorized show only personal, favourite and basket items.
     * @returns {*}
     */
    getPersonalMenu() {
      return this.personalMenuMobile.items.find((el) => el.href.match(/\/personal\/$/));
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-mobile-main {
  position: fixed;
  z-index: 3;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
  background-color: #fff;
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    height: 56px;
  }
  &__logo {
    width: 78px;
    height: 36px;
    fill: #030304;
  }
  &__close {
    cursor: pointer;
    svg {
      width: 24px;
      height: 24px;
    }
  }
  &__icon {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    fill: var(--background-black);
  }
  &__main {
    display: grid;
    grid-row-gap: 8px;
    padding: 16px 16px 0;
    overflow-y: auto;
    max-height: calc(100% - 56px);
    background-color: #f5f5f5;
    @include point-md {
      padding: 16px 24px 46px;
    }
  }
  &__menu {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 12px 16px;
    color: var(--color-golden-browm);
    text-transform: uppercase;
    .menu-mobile-main__icon {
      fill: currentColor;
    }
  }
  &__arrow {
    width: 20px;
    height: 20px;
    margin-left: auto;
    fill: var(--background-dark-grey);
  }
  :deep(.def-button-secondary) {
    margin-bottom: 16px;
    @include point-md {
      margin-bottom: 0;
      margin-right: 26px;
    }
  }
}
.menu-mobile-block {
  background-color: #fff;
  font-size: 16px;
  font-weight: 500;
  line-height: 125%;
  :deep(.delivery-country) {
    width: 100%;
    margin-right: 0;
  }
  :deep(.delivery-country-arrow) {
    transform: rotate(-90deg);
    margin-left: auto;
  }
  :deep(.delivery-country-text) {
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 125%;
  }
}
.menu-mobile-footer {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-row-gap: 20px;
  background-color: #fff;
  font-size: 16px;
  font-weight: 500;
  line-height: 125%;
  padding: 12px 16px;
  @include point-md {
    padding: 16px;
  }
}
.menu-footer-item {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-row-gap: 4px;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%;
  &__title {
    color: #5f5f67;
    font-size: 14px;
    font-weight: 600;
    line-height: 125%;
  }
  &__phone {
    font-size: 18px;
    font-weight: 600;
    line-height: 125%;
  }
}
.menu-mobile-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
}

.menu-mobile-times {
  display: flex;
  flex-direction: column;

  font-size: 16px;
  font-weight: 500;
  line-height: 125%;
  :deep(.footer-times__title) {
    font-size: 14px;
    font-weight: 600;
    line-height: 125%;
    color: #5f5f67;
    margin-bottom: 4px;
  }
}
.menu-mobile-service {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-auto-rows: 42px;
  &__item {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    line-height: 125%;
    padding: 0 16px;
  }
}
</style>
